import React from 'react';
import ReactDOM from 'react-dom';
import VideoGuides from 'common/components/VideoGuides';

ReactDOM.render(<VideoGuides />, document.getElementById('help-videos-container'));
